import { LogAPI } from './api/index.js';

export const log = LogAPI.getInstance();
